import {
  Directive,
  ElementRef,
  Renderer,
  Input,
  Output,
  HostListener,
  EventEmitter,
  OnChanges,
  OnInit
} from '@angular/core';
import * as bowser from 'bowser';

@Directive({
  selector: 'toggle-visible'
})
export class ToggleVisible implements OnInit, OnChanges {
  activeElement: any;
  @Input() isOpen: boolean;
  @Input() ignoreElement: any;
  @Input() ignoreClass: any;
  @Output() focusLost: EventEmitter<any> = new EventEmitter();
  @Output() closeOnClick: EventEmitter<any> = new EventEmitter();
  isVisible = false;
  isTabPressed = false;
  documentClickHandler: any;

  constructor(private el: ElementRef, private renderer: Renderer) {}
  @HostListener('document:touchstart', ['$event.target'])
  @HostListener('document:touch', ['$event.target'])
  @HostListener('document:click', ['$event.target'])
  onClick(targetElement) {
    if (
      this.ignoreElement &&
      this.ignoreElement.nativeElement.children[0].className ===
        targetElement.className &&
      !this.isVisible &&
      this.isOpen
    ) {
      this.isVisible = true;
      return;
    }
    if (
      this.ignoreClass &&
      this.ignoreClass === targetElement.className &&
      !this.isVisible &&
      this.isOpen
    ) {
      this.isVisible = true;
      return;
    }

    if (
      this.isOpen &&
      this.el.nativeElement !== targetElement &&
      !this.el.nativeElement.contains(targetElement)
    ) {
      this.activeElement = targetElement;
      this.closeOnClick.emit();
      this.isVisible = false;
    }
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event) {
    this.isTabPressed = event.keyCode === 9;
  }

  @HostListener('document:focusin', ['$event.target'])
  onFocus(targetElement: HTMLElement) {
    if (!this.isTabPressed) {
      return;
    }
    if (
      this.isOpen &&
      !this.el.nativeElement.contains(targetElement)
    ) {
      this.activeElement = targetElement;
      this.focusLost.emit();
      this.isVisible = false;
    }
    this.isTabPressed = false;
  }

  ngOnInit() {
    const documentElm = Object.assign({}, document);
    const mobileDevice =
      bowser.getParser(window.navigator.userAgent).getPlatformType() ===
      'mobile';
    const eventTouch = 'touchstart';
    const eventClick = 'click';
    const eventBind = mobileDevice ? eventTouch : eventClick;
    // this.documentClickHandler = ({ target }) => {
    //   // If already closed by some other trigger, do nothing
    //   if (this.isOpen && this.el.nativeElement !== target && !this.el.nativeElement.contains(target)) {
    //     this.activeElement = target;
    //     this.close.emit();
    //   }
    // };
  }

  ngOnChanges(changes: any) {
    //  this.documentClickHandler();
  }
}
